import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import  {MainTabicon}  from "../../shared/components/Tabicon"
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faHome, faComments, faUserCircle, faGift, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { colors } from '../../shared/const';
import localize from '../../shared/localize';

class DVBottomTabar extends Component {

  state = {
    value: 0,
  };

  handleChange = (route) => {
    return this.props.history.push('/' + route);
  };

  render() {
    const { active, userInfo } = this.props;
    let profileBudge = userInfo.unread_event && userInfo.unread_event !== 0 ? true : false;
    
    return (
      <div className="tab-size">
        <div className="icon-bar">
          <MainTabicon
            title={localize.home}
            tabIcon={(
              <Icon
                icon={faHome}
                style={{ position: "static", fontSize: 20, alignSelf: "center" }}
                color={active === "home" ? colors.white : colors.midnightBack}
              />
            )}
            active={active === "home" ? true : false}
            tab="home"
            onClick={() => this.handleChange('dashboard')}
          />

          <MainTabicon
            title={localize.chat}
            tabIcon={(
              <Icon
                icon={faComments}
                style={{ position: "static", fontSize: 20, alignSelf: "center" }}
                color={active === "chat" ? colors.white : colors.midnightBack}
              />
            )}
            active={active === "chat" ? true : false}
            tab="chat"
            onClick={() => this.handleChange('chat')}
          />

          <MainTabicon
            title={localize.profile}
            tabIcon={(
              <Icon
                icon={faUserCircle}
                style={{ position: "static", fontSize: 20, alignSelf: "center" }}
                color={active === "profile" ? colors.white : colors.midnightBack}
              />
            )}
            active={active === "profile" ? true : false}
            tab="profile"
            budge={profileBudge}
            onClick={() => this.handleChange('profile')}
          />

          <MainTabicon
            title={localize.reward}
            tabIcon={(
              <Icon
                icon={faGift}
                style={{ position: "static", fontSize: 20, alignSelf: "center" }}
                color={colors.disable}
              />
            )}
            active={active === "reward" ? true : false}
            tab="reward"
            onClick={() => null}
          />

          <MainTabicon
            title={localize.invite}
            tabIcon={(
              <Icon
                icon={faUserPlus}
                style={{ position: "static", fontSize: 20, alignSelf: "center" }}
                color={active === "invite" ? colors.white : colors.midnightBack}
              />
            )}
            active={active === "invite" ? true : false}
            tab="invite"
            onClick={() => this.handleChange('invite')}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ setting, auth }) => {
  return {
    setting: setting,
    userInfo: auth.userInfo,
  }
}

export default withRouter(connect(mapStateToProps)(DVBottomTabar));